import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MachineLastState } from '../../_models/machinaries/machineLastState';
import { TankLastState } from '../../_models/machinaries/tankLastState';
import { environment } from '../../../../environments/environment';

@Injectable()
export class MachineLastStateService {
  private apiBaseUrl = environment.apiBaseUrl;
  private telemetryServiceUrl = environment.telemetryServiceUrl;

  constructor(private http: HttpClient) {}

  getMachineLastState(
    equipmentId,
    externalSource = null,
    externalId = null
  ): Observable<MachineLastState> {
    return this.http
      .get<any>(
        this.telemetryServiceUrl +
          'api/equipmentTelemetry/getLastState?equipmentId=' +
          equipmentId +
          (externalSource != null ? '&externalSource=' + externalSource : '') +
          (externalId != null ? '&externalId=' + externalId : '')
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getTankLastState(equipmentId): Observable<TankLastState> {
    return this.http
      .get<any>(
        this.apiBaseUrl +
          'api/private/v1/equipmentTelemetry/getLastState?equipmentId=' +
          equipmentId
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getLastStateByEquipmentType(
    equipmentId,
    type,
    externalSource = null,
    externalId = null
  ): Observable<any> {
    return this.getLastState(equipmentId);
  }

  syncMachine(): Observable<any> {
    return this.http
      .get<any>(this.telemetryServiceUrl + 'api/equipmentTelemetry/syncEquipments')
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getLastState(
    equipmentId,
    externalSource = null,
    externalId = null
  ): Observable<MachineLastState> {
    return this.http
      .get<any>(
        this.telemetryServiceUrl +
          'api/equipmentTelemetry/getLastState?equipmentId=' +
          equipmentId +
          (externalSource != null ? '&externalSource=' + externalSource : '') +
          (externalId != null ? '&externalId=' + externalId : '')
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}
